module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10077.8b057902.jpg";